<div class="container-fluid ac-poppins mt-4">
  <div class="row">
    <div class="col-xl-12">
      <ul class="nav nav-pills ac-gborder mb-3" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link ac-tab-button active"
            id="pills-profile-tab"
            type="button"
            role="tab"
            [class.active]="selectedTab === 'historical-invoices'"
            (click)="changeTab('historical-invoices')"
          >
            Historical Invoices
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link ac-tab-button"
            id="pills-home-tab"
            type="button"
            role="tab"
            [class.active]="selectedTab === 'historical-payments'"
            (click)="changeTab('historical-payments')"
          >
            Historical Payments
          </button>
        </li>
      </ul>
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="historical-invoices"
          role="tabpanel"
        >
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
